import React from 'react';

const Process = () => {
  return (
    <section id="process" className="process-section">
      <div className="container">
        <div className="section-header text-center">
          <h2 className="section-title">Our Proven Process</h2>
          <p className="section-subtitle">How we take your business from vision to reality in 5 simple steps.</p>
        </div>

        <div className="process-timeline">
          <div className="process-step">
            <div className="step-number">01</div>
            <h3 className="step-title">Discovery</h3>
            <p className="step-desc">We start by understanding your goals and target audience.</p>
          </div>
          <div className="process-step">
            <div className="step-number">02</div>
            <h3 className="step-title">Strategy</h3>
            <p className="step-desc">Developing a customized plan to achieve your objectives.</p>
          </div>
          <div className="process-step">
            <div className="step-number">03</div>
            <h3 className="step-title">Execution</h3>
            <p className="step-desc">Our team gets to work implementing the strategies.</p>
          </div>
          <div className="process-step">
            <div className="step-number">04</div>
            <h3 className="step-title">Optimization</h3>
            <p className="step-desc">Continuous monitoring and tweaking for best results.</p>
          </div>
          <div className="process-step">
            <div className="step-number">05</div>
            <h3 className="step-title">Scale</h3>
            <p className="step-desc">Expanding successful campaigns to maximize ROI.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Process;
